import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { IncDataSrcEnumSelect } from './formFields/IncDataSrcEnumSelect';
import { useEffect, useState } from 'react';
import { useRsrc } from '@/common/rsrc/RsrcContext';

export const IncDataSrcForm = () => {

  const rsrc = useRsrc();

  const [fieldToTrxSrcCodeToEnumSpecs, setFieldToTrxSrcCodeToEnumSpecs] = useState();

  useEffect(() => {
    rsrc.data('gp', 'INC_DATA_SRC_ENUM_OPTIONS_DATA_PLUGIN').then((fieldToTrxSrcCodeToEnumSpecs) => {
      setFieldToTrxSrcCodeToEnumSpecs(fieldToTrxSrcCodeToEnumSpecs);
    })
  }, [])

  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.dateBasis.component = (
      <IncDataSrcEnumSelect
        key="dateBasis"
        fieldDef={fieldToFieldDef.dateBasis}
        trxSrcCodeToEnumSpecs={fieldToTrxSrcCodeToEnumSpecs.dateBasis}
      />
    )
    fieldToFieldDef.cutoffBasis.component = (
      <IncDataSrcEnumSelect
        key="cutoffBasis"
        fieldDef={fieldToFieldDef.cutoffBasis}
        trxSrcCodeToEnumSpecs={fieldToTrxSrcCodeToEnumSpecs.cutoffBasis}
      />
    )
  }

  // Don't render EntityForm until fieldToTrxSrcCodeToEnumSpecs has been fetched from server
  if (!fieldToTrxSrcCodeToEnumSpecs) {
    return null;
  }

  return (
    <EntityForm augFieldDefs={augFieldDefs} />
  )
}